import { Injectable } from '@angular/core';
import { EndpointConfig } from '../common/EndpointConfig';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SaveSaleMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { DefaultService } from '../common/default.service';
import { SaveBulkInstallmentRequest } from 'src/app/viewmodels/g-sale/GSaleViewModel';
import { SaveGQuotationRequest } from 'src/app/viewmodels/g-quotation/QuotationModel';

@Injectable({
  providedIn: 'root'
})
export class GSaleService {

  private _ep: EndpointConfig;
  constructor(private http: HttpClient, private _defaultService: DefaultService) {
    this._ep = new EndpointConfig('');
  }

  public GetFuelTypesAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSetting', 'GetFuelTypesAsync')}`);
  }

  public DeleteFuelTypeAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSetting', 'DeleteFuelTypeAsync')}/${id}`);
  }



  public SaveGBrandAsync(obj: any) {
    return this.http.post(`${this._ep.getControllerUrl('GSetting', 'SaveGBrandAsync')}`, obj);
  }

  public GetAllSaleOrdersExportAsync(id: number, fromDate: Date | string, toDate: Date | string, statusId: number) {
    const f = new Date(fromDate).toISOString().split('T')[0]; // yyyy-MM-dd
    const t = new Date(toDate).toISOString().split('T')[0];
    return this.http.get(
      `${this._ep.getControllerUrl('GSale', 'GetAllSaleOrdersExportAsync')}/${id}/${encodeURIComponent(f)}/${encodeURIComponent(t)}/${statusId}`
    );
  }

  public GetGSaleRefIdAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSale', 'GetGSaleRefIdAsync')}`);
  }

  public GetGSaleByIdAsync(id: string) {
    return this.http.get(`${this._ep.getControllerUrl('GSale', 'GetGSaleByIdAsync')}/${id}`);
  }


  SaveGSaleAsync(obj: SaveSaleMasterRequest) {
    console.log(obj);
    this._defaultService.dateTransFuckDatesInObject(obj);
    let fd = new FormData();
    debugger
    if (obj.file != undefined) {
      for (var i = 0; i < obj.file.length; i++) {
        fd.append('file', obj.file[i]);
      }
    }
    fd.append('Sale', JSON.stringify(obj));
    return this.http.post(`${this._ep.getControllerUrl('GSale', 'SaveGSaleAsync')}`, fd);
  }

  public DeleteGSaleAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSale', 'DeleteGSaleAsync')}/${id}`);
  }

  public UpdateGSaleStatusAsync(saleId: number, statusId: number) {
    return this.http.patch(`${this._ep.getControllerUrl('GSale', 'UpdateGSaleStatusAsync')}/${saleId}/${statusId}`, null);
  }

   public GetGInstallmentBySaleIdAsync(id: string) {
    return this.http.get(`${this._ep.getControllerUrl('GSale', 'GetGInstallmentBySaleIdAsync')}/${id}`);
  }

  public DeleteGBulkPaymentAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSale', 'DeleteGBulkPaymentAsync')}/${id}`);
  }

   public GetGBulkPaymentByIdAsync(id: string) {
    return this.http.get(`${this._ep.getControllerUrl('GSale', 'GetGBulkPaymentByIdAsync')}/${id}`);
  }

   public GetInvoiceByCustomerIdAsync(id: number, fromDate: string, toDate: string) {
    return this.http.get(`${this._ep.getControllerUrl('GSale', 'GetInvoiceByCustomerIdAsync')}/${id}/${fromDate}/${toDate}`);
  }

  public SaveBulkPaymentsAsync(obj: SaveBulkInstallmentRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GSale', 'SaveBulkPaymentsAsync')}`, obj);
  }

  public GetGBulkPaymentsRefIdAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSale', 'GetGBulkPaymentsRefIdAsync')}`);
  }

   public DeleteGQuotationAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GSale', 'DeleteGQuotationAsync')}/${id}`);
  }

  public GetGQuotationRefIdAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GSale', 'GetGQuotationRefIdAsync')}`);
  }

  SaveGQuotationAsync(obj: SaveGQuotationRequest) {
    console.log(obj);
    this._defaultService.dateTransFuckDatesInObject(obj);
    let fd = new FormData();
    debugger
    if (obj.file != undefined) {
      for (var i = 0; i < obj.file.length; i++) {
        fd.append('file', obj.file[i]);
      }
    }
    fd.append('Quotation', JSON.stringify(obj));
    return this.http.post(`${this._ep.getControllerUrl('GSale', 'SaveGQuotationAsync')}`, fd);
  }

  public GetGQuotationByIdAsync(id: string) {
    return this.http.get(`${this._ep.getControllerUrl('GSale', 'GetGQuotationByIdAsync')}/${id}`);
  }

  public getList(
    controller: string,
    action: string,
    page: number,
    size: number,
    searchObj: any = {},
    orderBy: string = 'Desc',
    sort: string = '',
    flag: string = ''
  ) {
    let params = new HttpParams()
      .set('Page', page.toString())
      .set('Size', size.toString());

    if (flag !== undefined && flag !== null && flag !== '') {
      params = params.set('Flag', flag.toString());
    }

    // Use Object.keys to iterate over the properties of searchObj
    Object.keys(searchObj).forEach(key => {
      const value = searchObj[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(`Search.${key}`, value.toString());
      }
    });

    if (orderBy) {
      params = params.set('OrderBy', orderBy);
    }
    if (sort) {
      params = params.set('Sort', sort);
    }

    return this.http.get(`${this._ep.getControllerUrl(controller, action)}`, { params });
  }



  public getListById(
    controller: string,
    action: string,
    page: number,
    size: number,
    searchObj: any = {},
    orderBy: string = '',
    sort: string = '',
    id?: string | number // add Id param here, optional
  ) {
    let params = new HttpParams()
      .set('Page', page.toString())
      .set('Size', size.toString());

    // Add Id if provided
    if (id !== undefined && id !== null && id !== '') {
      params = params.set('Id', id.toString());
    }

    // Use Object.keys to iterate over searchObj properties
    Object.keys(searchObj).forEach(key => {
      const value = searchObj[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(`Search.${key}`, value.toString());
      }
    });

    if (orderBy) {
      params = params.set('OrderBy', orderBy);
    }
    if (sort) {
      params = params.set('Sort', sort);
    }

    return this.http.get(`${this._ep.getControllerUrl(controller, action)}`, { params });
  }
}
